module.exports = __webpack_public_path__ + "img/shop_A_2.4175f633.png";